import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shop-sidebar-category-menu-and-filters',
  templateUrl: './shop-sidebar-category-menu-and-filters.component.html',
  styleUrls: ['./shop-sidebar-category-menu-and-filters.component.css']
})
export class ShopSidebarCategoryMenuAndFiltersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
